import { render, staticRenderFns } from "./Thresholds.vue?vue&type=template&id=0484d2b2&"
import script from "./Thresholds.vue?vue&type=script&lang=js&"
export * from "./Thresholds.vue?vue&type=script&lang=js&"
import style0 from "./Thresholds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports